import { useSyncExternalStore } from 'react'

/**
 * «Обновить» in the top bar and the background refresh (lib/freshness: a
 * save here or in another tab, the tab showing again): a counter that grows
 * on every refresh. A screen that loads its own dropdown or report data
 * (outside ListStore and the lookups) puts the counter in its effect's
 * dependencies, so a refresh fetches that data again. Effects that fill a
 * form's values must not use it: a refresh keeps what is typed.
 */
let tick = 0
const listeners = new Set<() => void>()

export function bumpRefresh() {
  tick += 1
  for (const listener of listeners) listener()
}

export function refreshTickNow() {
  return tick
}

function subscribe(listener: () => void) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export function useRefreshTick() {
  return useSyncExternalStore(subscribe, refreshTickNow, refreshTickNow)
}
